export function getLink({ category, vendor, page }) {
	if (category)
		return '/browse/category/' + category + '/page/' + (parseInt(page, 10) + 1);
	return '/browse/vendor/' + vendor + '/page/' + (parseInt(page, 10) + 1);
}
